import React from "react";
import { BrowserRouter } from "react-router-dom";
import { DataProvider } from "./contexts/DataContext";
import { ToastProvider } from "./contexts/ToastContext";
import AppShell from "./components/layout/AppShell";
import "./styles/global.css";
import "./auth/Auth.css";
import AllPermission from "./ProtectRoute/permissionRoutes";

function App() {
  return (
    <BrowserRouter>
      <DataProvider>
        <ToastProvider>
          <AllPermission>
            <AppShell />
          </AllPermission>
        </ToastProvider>
      </DataProvider>
    </BrowserRouter>
  );
}

export default App;